<template>
    <div>
        <flash-error ref="flashError"></flash-error>
        <progress-bar percentages="80"></progress-bar>
        <section id="service-section" class="py-2 mobile-container">
            <div class="d-flex align-items-center justify-content-between text-light">
                <div>Opsummering</div>
            </div>
        </section>
        <section id="text-section" class="mobile-container bg-light">
            <div class="py-2">
                <div class="mb-2"><strong>Dine valg:</strong></div>
                <div class="mb-2" v-if="additionalServicesProp[changeAddressKey] &&
                 additionalServicesProp[changeAddressKey].enabled"
                >
                    <div>{{ additionalServicesProp[changeAddressKey].value.name }}</div>
                    <div>
                        {{ additionalServicesProp[changeAddressKey].value.street }},
                        {{ additionalServicesProp[changeAddressKey].value.zip }}
                        {{ additionalServicesProp[changeAddressKey].value.city }},
                        <span v-if="booking.dropoff_address.country">{{ booking.dropoff_address.country.name }}</span>
                    </div>
                    <div>{{ additionalServicesProp[changeAddressKey].value.phone }}</div>
                    <div v-if="additionalServicesProp[changeAddressKey].price > 0">
                        (+{{ additionalServicesProp[changeAddressKey].price }} kr.)
                    </div>
                </div>
                <div class="mb-2" v-else>
                    <div>{{ booking.dropoff_address.name }}</div>
                    <div>
                        {{ booking.dropoff_address.street }},
                        {{ booking.dropoff_address.zip }}
                        {{ booking.dropoff_address.city }},
                        <span v-if="booking.dropoff_address.country">{{ booking.dropoff_address.country.name }}</span>
                    </div>
                    <div>{{ booking.dropoff_address.phone }}</div>
                </div>
                <div class="mb-2">
                    <div>
                        <div v-if="booking.dropoff_trip && booking.dropoff_trip.time_communicated">Leveringsdato</div>
                        <div v-else>Leveringstidspunkt</div>
                        <div class="d-flex align-items-center"
                             v-if="booking.dropoff_trip && booking.dropoff_trip.time_communicated"
                        >
                            <span class="material-icons-outlined small cursor-pointer pr-1">event</span>
                            <span v-if="additionalServicesProp[newDeliveryDateKey] &&
                            additionalServicesProp[newDeliveryDateKey].enabled">
                                {{ additionalServicesProp[newDeliveryDateKey].value.replace(/\(.*/, '') }}
                                <span v-if="additionalServicesProp[newDeliveryDateKey].price > 0">
                                    (+{{ additionalServicesProp[newDeliveryDateKey].price }} kr.)
                                </span>
                            </span>
                            <span v-else>
                                {{ formatDate(autopushedDate ? autopushedDate : booking.dropoff_end, 'DD-MM-yyyy') }}
                            </span>
                        </div>
                        <div class="d-flex align-items-center"
                             v-if="dropoffStartTime || dropoffEndTime">
                            <span class="material-icons-outlined small cursor-pointer pr-1">schedule</span>
                            <span>{{ dropoffStartTime }} - {{ dropoffEndTime }}</span>
                            <span class="ml-1" v-if="additionalServicesProp[shorterTimeIntervalKey] &&
                             additionalServicesProp[shorterTimeIntervalKey].enabled &&
                              additionalServicesProp[shorterTimeIntervalKey].price > 0"
                            >
                                (+{{ additionalServicesProp[shorterTimeIntervalKey].price }} kr.)
                            </span>
                        </div>
                    </div>
                </div>
                <div class="mb-4">
                    <div class="mb-1" v-for="(service, key) in additionalServicesProp"
                         v-if="service.enabled &&
                          (service.value || service.price) && ![changeAddressKey, newDeliveryDateKey, shorterTimeIntervalKey].includes(key)">
                        <span>{{ service.name }}:</span>
                        <span>{{ service.value }}</span>
                        <span>(+{{ service.price }} kr.)</span>
                    </div>
                    <div class="mb-1" v-for="(service) in additionalServicesProp[additionalServicePrime]" v-if="typeof(service) === 'object' && service.enabled">
                        <span>{{ service.name }}:</span>
                        <span>(+{{ service.price }} kr.)</span>
                    </div>
                </div>
                <div v-if="totalPrice > 0" class="d-flex align-items-start justify-content-between">
                    <div class="mr-4">
                        <input type="checkbox"
                               id="accept-terms"
                               v-model="acceptTerms"
                        >
                    </div>
                    <div>
                        <label for="accept-terms" class="mb-4">
                            Jeg godkender, at ydelsen udføres inden min 14 dages fortrydelsesret udløber,
                            og at fortrydelsesretten ophører, når ydelsen er påbegyndt.
                            Læs mere i
                            <a @click.prevent="openModalIframe('Handelsbetingelser', 'https://steptransport.dk/handelsbetingelser.html')"
                               href="#"
                            >handelsbetingelserne</a>.
                        </label>
                    </div>
                </div>
                <div class="d-flex align-items-center justify-content-between">
                    <button
                        class="btn btn-primary"
                        @click="openModalIframe('Kundeguide', 'https://www.steptransport.dk/kundeguide.html')"
                    >Hjælp</button>
                    <button class="btn btn-success" :disabled="totalPrice > 0 && !acceptTerms" @click="submit">
                        <span v-if="totalPrice > 0">Bekræft og betal {{ totalPrice }} kr.</span>
                        <span v-else>Bekræft</span>
                    </button>
                </div>
            </div>
        </section>
        <back-section :url="prevUrl" type="2"></back-section>

        <div
            ref="modalInsurance"
            class="modal fade"
            :class="{show, 'd-block': activeModalInsurance}"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Info</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModalInsurance"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-3">
                            Hov, vi kan se at du ikke har valgt at forsikre dine varer.
                            Vi passer naturligvis så godt på din levering som overhovedet muligt,
                            men vi anbefaler altid at være på din sikre side.
                        </div>
                        <div class="mb-3">Du kan tilkøbe en vareforsikring på dit produkt for
                            {{ (additionalServicesProp[additionalServiceInsurance] &&
                                additionalServicesProp[additionalServiceInsurance].price) ?
                                additionalServicesProp[additionalServiceInsurance].price :
                                ''
                            }} kr.
                        </div>
                        <div class="mb-3">Ønsker du at tilkøbe en vareforsikring?</div>
                        <div>
                            Yderligere information omkring forsikring finder du i vores
                            <a href="#"
                               @click.prevent="openModalIframe(
                                   'Kundeguide',
                                   'https://www.steptransport.dk/kundeguide.html'
                                   )">kundeguide
                            </a>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <div class="d-flex align-items-center justify-content-between w-100">
                            <button class="btn btn-primary mb-1" data-dismiss="modal" @click="goNext">
                                Nej
                            </button>
                            <button class="btn btn-success mb-1" data-dismiss="modal" @click="addInsurance">
                                Ja
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <modal-iframe
            :title="modalTitle"
            :src="modalSrc"
            ref="modal-iframe"
            @toggleActiveIframeModalInterval="toggleActiveIframeModalInterval"
        ></modal-iframe>
        <div v-if="activeIframeModalInterval || activeModalInsurance" class="modal-backdrop fade show"></div>

    </div>

</template>

<script>
import ProgressBar from "./reusable/ProgressBar.vue";
import BackSection from "./reusable/BackSection.vue";
import ModalIframe from "./reusable/ModalIframe.vue";
import FlashError from "./reusable/FlashError.vue";
import dateTimeMixin from "../../mixins/dateTimeMixin";
export default {
    name: "CmfStep5",
    components: {FlashError, ModalIframe, ProgressBar, BackSection},
    mixins: [dateTimeMixin],
    props: {
        booking: {type: Object, required: true},
        nextUrl: {type: String, required: true},
        prevUrl: {type: String, required: true},
        applyChangesUrl: {type: String, required: true},
        additionalServicesProp: {type: Object|Array, required: true},
        changeAddressKey: {type: String, required: true},
        additionalServiceShorterTimeInterval: {type: String, required: true},
        additionalServiceInsurance: {type: String, required: true},
        additionalServicePrime: {type: String, required: true},
        newDeliveryDateKey: {type: String, required: true},
        permitsKey: {type: String, required: true},
        shorterTimeIntervalKey: {type: String, required: true},
        configurations: {type: Object, required: true},
        autopushedDate: {type: String, required: false, default: ''}
    },
    data() {
        return {
            activeIframeModalInterval: false,
            totalPrice: 0,
            acceptTerms: false,
            dropoffStartTime: '',
            dropoffEndTime: '',
            modalTitle: '',
            modalSrc: '',
            activeModalInsurance: false,
            show: false
        }
    },
    created() {
        this.calculateTotalPrice(this.additionalServicesProp);

        if (this.booking.dropoff_start) {
            this.dropoffStartTime = this.getDropoffTime(this.booking, 'start');
        }

        if (this.booking.dropoff_end) {
            this.dropoffEndTime = this.getDropoffTime(this.booking, 'end');
        }

        if (this.additionalServicesProp[this.shorterTimeIntervalKey] &&
            this.additionalServicesProp[this.shorterTimeIntervalKey].enabled
        ) {
            if (this.additionalServicesProp[this.shorterTimeIntervalKey].value['when'] === 'Before') {
                this.dropoffEndTime = this.additionalServicesProp[this.shorterTimeIntervalKey].value['time'];
                this.dropoffStartTime = this.configurations['default_time_from']['value'];
            } else {
                this.dropoffStartTime = this.additionalServicesProp[this.shorterTimeIntervalKey].value['time'];
                this.dropoffEndTime = this.configurations['default_time_to']['value'];
            }
        }
    },
    methods: {
        submit() {
            if (this.additionalServicesProp[this.additionalServiceInsurance] &&
                !this.additionalServicesProp[this.additionalServiceInsurance].enabled
            ) {
                this.toggleModalInsurance();
            } else {
                this.goNext();
            }
        },
        goNext() {
            axios.post(this.applyChangesUrl, {totalPrice: {key: 'totalPrice', value: this.totalPrice}})
                .then((response) => {
                    window.location.href = this.nextUrl;

                }).catch(error => {
                this.$refs.flashError.flashError(error);
            });

        },
        openModalIframe(title, src) {
            this.modalTitle = title;
            this.modalSrc = src;
            this.$refs["modal-iframe"].toggleModal();
        },
        toggleActiveIframeModalInterval() {
            this.activeIframeModalInterval = !this.activeIframeModalInterval;
        },
        calculateTotalPrice(obj) {
            for (let key in obj) {
                if (typeof obj[key] === 'object' && obj[key].enabled) {
                    this.totalPrice += obj[key].price ? parseFloat(obj[key].price) : 0;
                } else if (key === this.additionalServicePrime) {
                    this.calculateTotalPrice(obj[key]);
                }
            }
        },
        addInsurance() {
            let data = {};
            data[this.additionalServiceInsurance] = JSON.parse(JSON.stringify(this.additionalServicesProp[this.additionalServiceInsurance]));
            data[this.additionalServiceInsurance].enabled = true;
            axios.post(this.applyChangesUrl, data)
                .then((response) => {
                    window.location.href = window.location.href;

                }).catch(error => {
                this.$refs.flashError.flashError(error);
            });

        },
        toggleModalInsurance() {
            const body = document.querySelector("body");
            this.activeModalInsurance = !this.activeModalInsurance;
            this.activeIframeModalInterval
                ? body.classList.add("modal-open")
                : body.classList.remove("modal-open");
            setTimeout(() => (this.show = !this.show), 10);
        }
    },
}

</script>

<style scoped>

</style>
